export interface IFileData {
  content: File;
  metadata: {
    name: string;
    type: string;
    size: number;
  };
}

export const simpleMediaSize = 5 * 1024 * 1024; // simple media

export const MAX_VIDEO_SIZE = 100000000; // video limit 100MB

export const MAX_IMAGE_SIZE = 10000000; // image limit 10MB

/**
 * is simple media
 * @param size
 * @returns
 */
export const isSimpleMediaSize = (size: number): boolean => {
  return size < simpleMediaSize;
};

export const fileToData = async (selectedFile: File): Promise<IFileData> => {
  return new Promise((resolve, reject) => {
    const fileMetaData = {
      name: selectedFile.name,
      type: selectedFile.type,
      size: selectedFile.size,
    };

    const reader = new FileReader();
    reader.onload = async (e) => {
      const fileContent = e?.target?.result;

      resolve({
        content: new File([fileContent!], selectedFile.name, { type: selectedFile.type }),
        metadata: fileMetaData,
      });
    };

    reader.readAsArrayBuffer(selectedFile);
  });
};
